// extracted by mini-css-extract-plugin
module.exports = {"section":"oyW05-I4pplfmreHEL7cy","container":"_2PQOLmrLzJp_vCIbTSq41k"};